export default __webpack_public_path__ + "static/media/backbutton.75dc84aa.svg";